import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Wrapper = styled('div')`
  margin: 73px 0 113px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;

  p {
    color: ${myPalette.white.main};
  }
`

export const Title = styled('div')`
  font-size: 22px;
  text-align: center;
  font-weight: 500;
  color: ${myPalette.white.main};
`
